module.exports = __webpack_public_path__ + "987b0e7b0bbd21e7de5dd74b8acf2e17.svg";